module.exports = __webpack_public_path__ + "vue_assets/img/img_app_preview_win.dbdd10f2.png";